import ImageAltTextGenerator from '../../../src/components/content-ai-tools/ImageAltTextGenerator';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={ImageAltTextGenerator} />;
};

export default PublicDiscoveryKeywordsWrapped;
